export const currency = (value: number) => {
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  return USDollar.format(value)
}

export const digit = (value: number) => {
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'decimal',
  })

  return USDollar.format(value)
}
